export const getOSName = (title) => {
  const fragments = title.split(' ');
  const version = parseInt(fragments[fragments.length - 1], 10);

  if (!fragments.length || !fragments[0]) {
    // handle empty title
    return 'unknown';
  }

  if (fragments.length === 1 && fragments[0].length > 0) {
    // split into fragments but it's a single value; for example "Linux"
    return fragments[0];
  }

  if (fragments[0] === 'macOS' || fragments[0] === 'OS') {
    // handle macOS both old and new conventions
    return 'macOS';
  }

  if (!version) {
    // version could not be parsed; assume the name has no version included
    return fragments.join(' ');
  }

  // otherwise, it successfully split the string into name and version
  return fragments.slice(0, -1).join(' ');
};

export const getBrowserName = (title) => {
  const fragments = title.split(' ');
  const version = fragments[fragments.length - 1];

  if (!fragments.length || !fragments[0]) {
    // handle empty title
    return 'unknown';
  }

  if (fragments.length === 1 && fragments[0].length > 0) {
    // split into fragments but it's a single value
    return fragments[0];
  }

  if (/^dev|beta/.test(version)) {
    // versions like 'dev' or 'beta' are ok
    return fragments.slice(0, -1).join(' ');
  }

  if (!parseInt(version, 10)) {
    // version could not be parsed; assume the name has no version included
    return fragments.join(' ');
  }

  // otherwise, it successfully split the string into name and version
  return fragments.slice(0, -1).join(' ');
};
